import React, { useState } from "react";
import { Download, MoreHorizontal, Shield, Settings } from "lucide-react";

const backupHistory = [
  { name: "Daily Backup - Jun 19, 2026", date: "Jun 19, 2026 11:30 PM", size: "12.4 GB", status: "Successful" },
  { name: "Daily Backup - Jun 18, 2026", date: "Jun 18, 2026 11:30 PM", size: "12.1 GB", status: "Successful" },
  { name: "Daily Backup - Jun 17, 2026", date: "Jun 17, 2026 11:30 PM", size: "11.8 GB", status: "Successful" },
  { name: "Weekly Backup - Jun 14, 2026", date: "Jun 14, 2026 11:30 PM", size: "48.6 GB", status: "Successful" },
  { name: "Weekly Backup - Jun 07, 2026", date: "Jun 07, 2026 11:30 PM", size: "47.9 GB", status: "Successful" },
];

const tabs = ["Backups", "Restore", "Retention Policies"];

export default function BackupRecovery() {
  const [activeTab, setActiveTab] = useState("Backups");
  const [openMenu, setOpenMenu] = useState(null);

  return (
    <div className="br-page">
      <div className="br-topbar">
        <div className="br-actions">
          <button className="br-btn br-btn-primary">
            <Shield size={16} />
            Backup Now
          </button>
          <button className="br-btn br-btn-secondary">
            <Settings size={16} />
            Backup Settings
          </button>
        </div>
      </div>

      <div className="br-tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`br-tab ${activeTab === tab ? "br-tab-active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {activeTab === "Backups" && (
        <>
          <h2 className="br-section-title">Backup Overview</h2>
          <div className="br-overview-grid">
            <div className="br-card">
              <div className="br-card-label">Last Backup</div>
              <div className="br-card-value">Jun 19, 2026 11:30 PM</div>
              <div className="br-status br-status-success">Successful</div>
            </div>
            <div className="br-card">
              <div className="br-card-label">Next Backup</div>
              <div className="br-card-value">Jun 20, 2026 11:30 PM</div>
              <div className="br-status br-status-info">Scheduled</div>
            </div>
            <div className="br-card">
              <div className="br-card-label">Total Backups</div>
              <div className="br-card-value">124</div>
              <div className="br-card-sub">All Time</div>
            </div>
            <div className="br-card">
              <div className="br-card-label">Storage Used</div>
              <div className="br-card-value">256.7 GB</div>
              <div className="br-card-sub">of 1 TB</div>
            </div>
          </div>

          <h2 className="br-section-title">Backup History</h2>
          <div className="br-table-wrap">
            <table className="br-table">
              <thead>
                <tr>
                  <th>Backup Name</th>
                  <th>Date &amp; Time</th>
                  <th>Size</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {backupHistory.map((row) => (
                  <tr key={row.name}>
                    <td className="br-cell-name">{row.name}</td>
                    <td className="br-cell-muted">{row.date}</td>
                    <td className="br-cell-muted">{row.size}</td>
                    <td>
                      <span className="br-badge">{row.status}</span>
                    </td>
                    <td>
                      <div className="br-row-actions">
                        <button className="br-icon-btn" title="Download">
                          <Download size={15} />
                        </button>
                        <div className="br-menu-wrap">
                          <button
                            className="br-icon-btn"
                            title="More"
                            onClick={() =>
                              setOpenMenu(openMenu === row.name ? null : row.name)
                            }
                          >
                            <MoreHorizontal size={15} />
                          </button>
                          {openMenu === row.name && (
                            <div className="br-menu">
                              <button>Restore</button>
                              <button>Rename</button>
                              <button className="br-menu-danger">Delete</button>
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <h2 className="br-section-title">Recovery Points</h2>
          <div className="br-recovery-card">
            <div className="br-recovery-item">
              <div className="br-card-label">Earliest Recovery Point</div>
              <div className="br-card-value">May 20, 2026 11:30 PM</div>
            </div>
            <div className="br-recovery-item">
              <div className="br-card-label">Latest Recovery Point</div>
              <div className="br-card-value">Jun 19, 2026 11:30 PM</div>
            </div>
            <button className="br-btn br-btn-outline">View All Recovery Points</button>
          </div>
        </>
      )}

      {activeTab === "Restore" && (
        <div className="br-empty">Restore options will appear here.</div>
      )}
      {activeTab === "Retention Policies" && (
        <div className="br-empty">Retention policy settings will appear here.</div>
      )}

      <style>{`
        .br-page {
          --br-bg: #ffffff;
          --br-surface: #ffffff;
          --br-border: #e7e8ec;
          --br-text: #14161a;
          --br-muted: #6b7280;
          --br-primary: #4f39f6;
          --br-primary-hover: #4330d9;
          --br-success-bg: #e8f8ee;
          --br-success-text: #16a34a;
          --br-info-text: #2563eb;
          --br-radius: 12px;

          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
          background: var(--br-bg);
          color: var(--br-text);
          margin: -24px;
          width: calc(100% + 48px);
          min-height: calc(100% + 48px);
          padding: 28px 32px 40px;
          box-sizing: border-box;
        }
        .br-page * { box-sizing: border-box; }

        .br-topbar {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-bottom: 18px;
        }
        .br-actions {
          display: flex;
          gap: 10px;
        }

        .br-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 500;
          padding: 10px 16px;
          border-radius: 8px;
          border: 1px solid var(--br-border);
          background: var(--br-surface);
          color: var(--br-text);
          cursor: pointer;
          transition: background 0.15s ease, border-color 0.15s ease;
          white-space: nowrap;
        }
        .br-btn-primary {
          background: var(--br-primary);
          border-color: var(--br-primary);
          color: #fff;
        }
        .br-btn-primary:hover { background: var(--br-primary-hover); }
        .br-btn-secondary:hover { background: #f7f7f9; }
        .br-btn-outline {
          color: var(--br-primary);
          border-color: var(--br-border);
        }
        .br-btn-outline:hover { background: #f5f4ff; }

        .br-tabs {
          display: flex;
          gap: 4px;
          border-bottom: 1px solid var(--br-border);
          margin-bottom: 18px;
        }
        .br-tab {
          background: none;
          border: none;
          font-size: 14px;
          font-weight: 500;
          color: var(--br-muted);
          padding: 10px 16px;
          cursor: pointer;
          border-bottom: 2px solid transparent;
          margin-bottom: -1px;
          transition: color 0.15s ease, border-color 0.15s ease;
        }
        .br-tab:hover { color: var(--br-text); }
        .br-tab-active {
          color: var(--br-primary);
          border-bottom-color: var(--br-primary);
        }

        .br-section-title {
          font-size: 16px;
          font-weight: 600;
          margin: 20px 0 12px;
        }
        .br-section-title:first-of-type { margin-top: 0; }

        .br-overview-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 16px;
        }
        .br-card {
          border: 1px solid var(--br-border);
          border-radius: var(--br-radius);
          padding: 18px;
          background: var(--br-surface);
        }
        .br-card-label {
          font-size: 13px;
          color: var(--br-muted);
          margin-bottom: 8px;
        }
        .br-card-value {
          font-size: 17px;
          font-weight: 600;
          margin-bottom: 8px;
        }
        .br-card-sub {
          font-size: 13px;
          color: var(--br-muted);
        }
        .br-status {
          font-size: 13px;
          font-weight: 500;
        }
        .br-status-success { color: var(--br-success-text); }
        .br-status-info { color: var(--br-info-text); }

        .br-table-wrap {
          border: 1px solid var(--br-border);
          border-radius: var(--br-radius);
          overflow: hidden;
        }
        .br-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 14px;
        }
        .br-table thead th {
          text-align: left;
          font-weight: 500;
          color: var(--br-muted);
          font-size: 13px;
          padding: 14px 18px;
          border-bottom: 1px solid var(--br-border);
          background: #fafafb;
        }
        .br-table tbody td {
          padding: 16px 18px;
          border-bottom: 1px solid var(--br-border);
        }
        .br-table tbody tr:last-child td { border-bottom: none; }
        .br-cell-name { font-weight: 500; }
        .br-cell-muted { color: var(--br-muted); }

        .br-badge {
          display: inline-block;
          font-size: 12px;
          font-weight: 500;
          color: var(--br-success-text);
          background: var(--br-success-bg);
          padding: 4px 10px;
          border-radius: 999px;
        }

        .br-row-actions {
          display: flex;
          gap: 6px;
          align-items: center;
        }
        .br-icon-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 30px;
          height: 30px;
          border-radius: 7px;
          border: 1px solid var(--br-border);
          background: var(--br-surface);
          color: var(--br-text);
          cursor: pointer;
        }
        .br-icon-btn:hover { background: #f5f5f7; }

        .br-menu-wrap { position: relative; }
        .br-menu {
          position: absolute;
          right: 0;
          top: 36px;
          background: #fff;
          border: 1px solid var(--br-border);
          border-radius: 8px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.08);
          display: flex;
          flex-direction: column;
          min-width: 130px;
          z-index: 5;
          overflow: hidden;
        }
        .br-menu button {
          background: none;
          border: none;
          text-align: left;
          font-size: 13px;
          padding: 9px 14px;
          cursor: pointer;
          color: var(--br-text);
        }
        .br-menu button:hover { background: #f5f5f7; }
        .br-menu-danger { color: #dc2626 !important; }

        .br-recovery-card {
          border: 1px solid var(--br-border);
          border-radius: var(--br-radius);
          padding: 18px 20px;
          display: flex;
          align-items: center;
          gap: 40px;
        }
        .br-recovery-item { flex: 1; }
        .br-recovery-card .br-btn-outline { margin-left: auto; }

        .br-empty {
          padding: 60px 0;
          text-align: center;
          color: var(--br-muted);
          font-size: 14px;
          border: 1px dashed var(--br-border);
          border-radius: var(--br-radius);
        }

        @media (max-width: 800px) {
          .br-overview-grid { grid-template-columns: repeat(2, 1fr); }
          .br-recovery-card { flex-direction: column; align-items: flex-start; gap: 16px; }
          .br-recovery-card .br-btn-outline { margin-left: 0; }
        }
        @media (max-width: 520px) {
          .br-overview-grid { grid-template-columns: 1fr; }
          .br-page { padding: 20px 16px 40px; margin: -24px; width: calc(100% + 48px); }
          .br-table-wrap { overflow-x: auto; }
          .br-table { min-width: 640px; }
        }
      `}</style>
    </div>
  );
}